<template lang="pug">
div
    CrudForm(v-bind="form" :customRules="customRules" @submitForm="handleSubmit($event)")
    v-text-field 
</template>

<script>
import CrudForm from '@/components/CrudForm/CrudForm'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import RUTInput from '@/components/RUTInput/RUTInput'

export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            formData: {},
            form: {
                toolbarTitle: 'Usuario',
                toolbarIcon: 'supervised_user_circle',
                submitText: 'Editar Usuario',
                editable: false,
                readOnly: false,
                disabled: false,
                fields: [
                    {
                        field: 'name',
                        type: 'text',
                        maxLength: 15,
                        value: 'Juanasdfasdf',
                        vuetifyProps: {
                            label: 'Nombre',
                        },
                        rules: ['required', 'charsOnly'],
                    },
                    {
                        field: 'rut',
                        type: 'rut',
                        maxLength: 12,
                        value: '170169778',
                        vuetifyProps: {
                            textFieldProps: {
                                label: 'RUT',
                            },
                        },
                    },
                    {
                        field: 'password',
                        type: 'password',
                        maxLength: 12,
                        value: '',
                        vuetifyProps: {
                            label: 'Contraseña',
                        },
                    },
                    {
                        field: 'parent_surname',
                        type: 'text',
                        maxLength: 15,
                        value: 'Gonzalez',
                        vuetifyProps: {
                            label: 'Apellido Paterno',
                        },
                    },
                    {
                        field: 'mother_surname',
                        type: 'text',
                        maxLength: 15,
                        value: 'Perez',
                        vuetifyProps: {
                            label: 'Apellido Materno',
                        },
                    },
                    {
                        field: 'city',
                        type: 'autocomplete',
                        value: 'La Serena',
                        vuetifyProps: {
                            label: 'Ciudad',
                        },
                        options: [
                            'La Serena',
                            'Coquimbo',
                            'Copiapó',
                            'Santiago',
                        ],
                    },
                    {
                        field: 'is_admin',
                        type: 'checkbox',
                        maxLength: 15,
                        value: false,
                        vuetifyProps: {
                            label: 'Permisos de Administrador',
                            style: {
                                'margin-right': '30px !important',
                            },
                        },
                    },
                    {
                        field: 'comments',
                        type: 'textarea',
                        value: '',
                        vuetifyProps: {
                            label: 'Comentarios',
                            box: true,
                            'no-resize': true,
                        },
                    },
                    {
                        field: 'text',
                        type: 'text',
                        value: '',
                        vuetifyProps: {
                            label: 'Prueba',
                        },
                    },
                ],
            },

            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
        }
    },
    computed: {},
    methods: {
        handleSubmit(event) {
            this.formData = event
        },
        testingSpacemacs: function(){
            const arr = [1,2,3,4]
            let arr2 = arr.map(item => item + 3)
            this.components
           }
    },
    watch: {},
    components: { CrudForm, RUTInput },
    mixins: [InputValidations, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
